<style lang="less" scope>
  .wz-comment-list {
    //padding: 0.2rem;
    min-height : 100vh;
   
  }
  .wz-comment-list__body {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    align-items: stretch;
    justify-content: space-between;
    flex-wrap: wrap;
  }
</style>
<template>
  <div class="wz-comment-list">
    <slot name="head"></slot>    
      <div v-if="list && list.length" class="wz-comment-list__body">        
        <wz-comment-item
          v-for="comment in list"
          :key="comment.cid"
          :comment="comment"
          :users="userMap"
        ></wz-comment-item>
        <div class="" v-if="list.length%2" style="width:50%; height:3.3rem; background:#fff"></div>        
      </div>
    <template v-if="!noMore">
      <div v-if="noData">
        <p class="ta-center cl-white loadMore">暂无更多评论</p>
      </div>
      <div v-else class="ta-center cl-white loadMore" @click="loadMore">点击加载更多</div>
    </template>
    
    <slot name="foot"></slot>    
  </div>
</template>

<script>
  import { commentList } from '../../api/g/comment'
  import {XEnv,XUtils} from '../../common/globals'
  export default {
    name: 'wz-comment-list',
    data() {
      return {
        list: [],
        userMap: {},
        noData : false,
        beforeCid : 0,
        loading: false,
        finished: false
      }
    },
    props: {
      objType: { type: [Number, String], default: 0 },
      objId: { type: [Number, String], default: 0 },
      start: { type: Number, default: 0 },
      pageNum: { type: [Number, String], default: 20 },
      noMore: { type: [Number, String], default: 0 },
      params: { type: Object, default: null }
    },
    computed: {
      query() {
        const { objType, objId, start, pageNum, params, beforeCid } = this
        return {
          ...params,
          totalFlag: 1,
          objType,
          objId,
          start,
          pageNum,
          beforeCid
        }
      }
    },
    methods: {
      loadMore(){
        this.fetch()
      },
      user(uid) {
        return this.userMap[uid] || { uid: uid, nick: `xs_${uid}`, logoSrc: '' }
      },
      async fetch() {
        const { query } = this
        const { total, list, userMap } = await commentList(query)
        // 加载状态结束
        this.loading = false
        this.userMap = XUtils.assign(this.userMap, userMap || {})
        this.list = this.list.concat(list || [])
        /* for(var i=0; i<list.length; i++){
          this.list.push(list[i])
        } */
        if(list.length <= 0){
          this.finished = true
        } else {
          this.beforeCid = this.list[this.list.length-1].cid || 0
        }
        if(this.list.length >= total){
          this.noData = true
        }
        // console.log(list)
        
        this.$emit('success', {
          query,
          total
        })
      }
    },
    watch: {
      query() {
        //this.fetch()
      }
    },
    created() {
      this.fetch()
    },
    beforeDestroy() {}
  }
</script>
